import { GROUP_REQUIREMENT_REF_PREFIX } from './requirementRef.util'

// Mirrors backend/src/lambdas/service/hub/microsoft/groupRequirements/groupRequirementUtils.js's
// sentinel format: a "group:<requirementId>" string diverts a group-bearing field into automatic
// resolution at deploy time, alongside literal Graph group GUIDs.
export const REQUIREMENT_REF_PREFIX = GROUP_REQUIREMENT_REF_PREFIX

export const isRequirementRef = (value) => typeof value === 'string' && value.startsWith(REQUIREMENT_REF_PREFIX)

export const getRequirementId = (value) => (isRequirementRef(value) ? value.slice(REQUIREMENT_REF_PREFIX.length) : null)

export const toRequirementRef = (requirementId) => `${REQUIREMENT_REF_PREFIX}${requirementId}`

// Mirrors backend groups-validators.js's GROUP_DISPLAY_NAME_MAX_LENGTH — a requirement's name
// becomes the created group's displayName verbatim, and Entra ID rejects anything longer.
export const GROUP_DISPLAY_NAME_MAX_LENGTH = 256

// Mirrors backend/src/lambdas/service/hub/microsoft/groupRequirements/resolveGroupRequirements.js's
// RESOLUTION_STATUS — the preview endpoint's response is the one place these values cross the
// wire, so both status-driven UIs (the resolution summary and the deploy-gating check) key off
// this shared vocabulary instead of independently duplicating the same magic strings.
export const GROUP_REQUIREMENT_STATUS = {
  MATCHED: 'matched',
  CREATABLE: 'creatable',
  MULTI_MATCH: 'multiMatch',
  UNRESOLVABLE: 'unresolvable',
}

// Mirrors the `resolution` values resolveAndBindGroupsForDeploy.js reports per requirement once a
// deploy has actually run (unlike GROUP_REQUIREMENT_STATUS, which is the pre-deploy preview).
export const GROUP_REQUIREMENT_RESOLUTION = {
  CREATED: 'created',
  ADOPTED: 'adopted',
  CHOSEN: 'chosen',
}

// Mirrors a requirement definition's groupType (see createResolvedGroup.js): an assigned group is
// created empty, a dynamic one populates itself from its membership rule.
export const GROUP_REQUIREMENT_TYPE = {
  ASSIGNED: 'assigned',
  DYNAMIC: 'dynamic',
}

const GROUP_REQUIREMENT_RESULTS_HUB_TASK_KEY = 'group-requirement-results'
const NO_GROUP_REQUIREMENT_RESULTS = []

// The hub subscriber stores a finished deploy's per-requirement outcomes on the hub task as a JSON
// string (see hub-elastic.js's updateHubTaskStatusWithMeta). Only created/adopted/chosen entries are
// kept — those are the groups that actually exist in the tenant and are bound to the policy.
export const parseGroupRequirementResults = (hubTask) => {
  const raw = hubTask?.[GROUP_REQUIREMENT_RESULTS_HUB_TASK_KEY]
  if (!raw) {
    return NO_GROUP_REQUIREMENT_RESULTS
  }
  try {
    const results = JSON.parse(raw)
    return Array.isArray(results)
      ? results.filter((result) => Object.values(GROUP_REQUIREMENT_RESOLUTION).includes(result?.resolution))
      : NO_GROUP_REQUIREMENT_RESULTS
  } catch {
    return NO_GROUP_REQUIREMENT_RESULTS
  }
}
